export const namespaced = true;

const resourceClaims = [
  {
    'claims' : [], 
    'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
  },
  {
   'claims' : ['partnerID'], 
   'roles': ['Taz-Affiliate', 'Taz'],
  }
];

const allRoles = ['Taz-Admin', 'Taz-Media', 'Taz-Affiliate', 'Taz', 'Taz-Reporting'];

export const state = {  
  namespaced: true,
  rolePermissionData: [
      //partner
      {
        'resource': 'CreatePartner',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['CreatePartner-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },      
      {
        'resource': 'ViewPartner',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewPartner-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
      //prompt
      {
        'resource': 'CreatePrompt',
        'roles': ['Taz-Admin'],
        'subResource' : [
          {
            'elements':['CreatePrompt-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      {
        'resource': 'ArchivePrompt',
        'roles': ['Taz-Admin']
      },
      {
        'resource': 'ViewPrompt',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewPrompt-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
      //campaign      
      {
        'resource': 'CreateCampaign',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['CreateCampaign-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      {
        'resource': 'ArchiveCampaign',
        'roles': ['Taz-Admin', 'Taz-Media']
      },
      {
        'resource': 'ViewCampaign',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewCampaign-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
      //callpath      
      {
        'resource': 'CreateCallpath',
        'roles': ['Taz-Admin'],
        'subResource' : [
          {
            'elements':['CreateCallpath-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      {
        'resource': 'ArchiveCallpath',
        'roles': ['Taz-Admin']
      },
      {
        'resource': 'ViewCallpath',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewCallpath-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
      //filter
      {
        'resource': 'CreateFilter',
        'roles': ['Taz-Admin'],
        'subResource' : [
          {
            'elements':['CreateFilter-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      {
        'resource': 'ViewFilter',
        'roles': ['Taz-Admin'],
        'subResource' : [
          {
            'elements':['ViewFilter-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      //dashboard
      {
        'resource': 'ViewDashboard',
        'roles': allRoles,
        'subResource' : [
          {
            'elements':['ViewDashboard-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Affiliate', 'Taz-Reporting'],
          },
        ]
      },
      //report
      {
        'resource': 'ViewReport',
        'roles': allRoles
      },
      {
        'resource': 'ViewCallLogReport',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewCallLogReport-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
      // By default the element will be hidden, show them if it satisfies all the claims for the given roles
      { 
        'resource': 'ViewAffiliateSummaryReport',
        'roles': allRoles,
        'resourceClaims' : resourceClaims,
        'subResource': [
          {
            'elements':['ViewAffiliateSummaryReport-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Affiliate', 'Taz-Reporting'],
          },
          {
            'elements':['AffiliatePartner'],
            'claims' : [], 
            'roles': ['Taz-Admin','Taz-Media', 'Taz-Reporting'],
          }
        ]
      }, 
      {
        'resource': 'ViewAffiliateLogReport',
        'roles': allRoles,
        'resourceClaims' : resourceClaims,
        'subResource': [
          {
            'elements':['ViewAffiliateLogReport-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Affiliate', 'Taz-Reporting'],
          },
          {
            'elements':['AffiliatePartner'],
            'claims' : [], 
            'roles': ['Taz-Admin','Taz-Media', 'Taz-Reporting'],
          }
        ]
      },
        // blockednumbers
      {
        'resource': 'ViewBlockedNumbers',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['ViewBlockedNumbers-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },      
      {
        'resource': 'UpdateBlockedNumbers',
        'roles': ['Taz-Admin']
      },
      //directmail
      {
        'resource': 'CreateDirectMail',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['CreateDirectMail-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz'],
          },
        ]
      },
      {
        'resource': 'ViewDirectMail',
        'roles': ['Taz-Admin', 'Taz-Media','Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewDirectMail-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz','Taz-Reporting'],
          },
        ]
      },
      //call details 
      {
        'resource': 'ViewTazDetails',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['ViewTazDetails-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media'],
          },
        ]
      },
      // holiday schedule
      {
        'resource': 'ViewHolidaySchedule',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['ViewHolidaySchedule-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media'],
          },
        ]
      },
      {
        'resource': 'UpdateHolidaySchedule',
        'roles': ['Taz-Admin']
      },
      // audit log
      {
        'resource': 'ViewAuditLog',
        'roles': ['Taz-Admin', 'Taz-Media'],
        'subResource' : [
          {
            'elements':['ViewAuditLog-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media'],
          },
        ]
      },
      // user Role
      {
        'resource': 'ViewUserRole',
        'roles': ['Taz-Admin'],
        'subResource' : [
          {
            'elements':['ViewUserRole-Menu'],
            'roles': ['Taz-Admin'],
          },
        ]
      },
      {
        'resource': 'UpdateUserRole',
        'roles': ['Taz-Admin']
      },
      //Inbound ping post      
      {
        'resource': 'ViewInboundPingPostDetailsReport',
        'roles': ['Taz-Admin', 'Taz-Media', 'Taz-Reporting'],
        'subResource' : [
          {
            'elements':['ViewInboundPingPostDetailsReport-Menu'],
            'roles': ['Taz-Admin', 'Taz-Media', 'Taz', 'Taz-Reporting'],
          },
        ]
      },
  ],
};


export const getters = {
  roleHasPermission: (state,getters,rootState, rootGetters) => (resourceName) => {
    let userRoles = rootGetters['auth/getUserRoles'];
    if (!userRoles) return false;
    let localData = deepCopy(state.rolePermissionData);
    let filteredArray = localData.filter(a=> a.resource.toLowerCase() == resourceName.toLowerCase());
    if(!filteredArray) {
      return false;
    }
    else {
      let item = filteredArray[0]; // there should be one match with the resource
      let hasPermission = userRoles.some(b => item.roles.indexOf(b.displayName) !== -1);
      if(hasPermission && item.resourceClaims && item.resourceClaims.length > 0) {
          hasPermission = false;
          let user = rootState.auth.user;
          let resourceClaims = item.resourceClaims;
          for(let i = 0; i < resourceClaims.length; i++) {
            let roles = resourceClaims[i].roles;
            let roleFilteredArray = user.roles.filter(roleObj => (roles.indexOf(roleObj.displayName) > -1));
            if(roleFilteredArray && roleFilteredArray.length > 0) {
              let claims = resourceClaims[i].claims;
              if(!claims || claims.length == 0) { // if no claims available, just show the resource
                 hasPermission = true;
              }
              else {
                if(user.partnerID && user.partnerID > 0) {
                   hasPermission = true;
                } 
              }
              if(hasPermission) {
                 break;
              }
            }
          }
      }
      return hasPermission;
    }        
  }, 
  
  
};

function deepCopy(input) {
  var output, v, key;
  output = Array.isArray(input) ? [] : {};
  for (key in input) {
      v = input[key];
      output[key] = (typeof v === "object") ? deepCopy(v) : v;
  }
  return output;
}

export const mutations = {};

export const actions = {};